import Vue from 'vue';
import { isInternetExplorer9 } from 'js/util/util.js'
// 说明: v-ie-placeholder 挂载在input||textarea父级及以上,挂在本身不生效,父级下多个input,给每个input增加父级元素在进行挂载，element可直接挂载el-input,el-select上
Vue.directive('ie-placeholder', {
    inserted: function (el, binding, vnode) {
        let placeholder = binding.value; //自定义placeholder
        el.className =  el.className +' v-ie-placeholder'; //必须有空格 全局增加ie-placeholder样式
        let input = el.querySelector('input')||el.querySelector('textarea');
        input&&bindBlaceholder(input,placeholder);
        /*
        ** IE9 el-input 删除键失效
        */
        if (isInternetExplorer9()) {
            let inputV = el.querySelector('.el-input__inner');
            inputV.addEventListener('keyup', function () {
                if (event.keyCode === 8) {
                    let valueAlias = vnode.data.model.expression;
                    getField(vnode.context, valueAlias, input.value);
                }
            })
        }
    }
})
function bindBlaceholder(element,placeholder) {
    if (!('placeholder' in document.createElement('input'))) {
        // 1. 原input
        element.addEventListener('focus', function () {
            this.nextSibling.style.display = 'none'
        })
        element.addEventListener('blur', function () {
            if (!this.value) {
                this.style.display = 'none'
                this.nextSibling.style.display = 'inline-block'
            }
        })

        //2.副本input
        let cloneNode = element.cloneNode();
        if(cloneNode.tagName.toLowerCase() === 'textarea'){
            // textarea
            cloneNode.innerText = placeholder||cloneNode.getAttribute('placeholder');
        } else {
            // input 如果[type='password']类型，则转为text
            if ((cloneNode.getAttribute('type') || 'text').toLowerCase() === 'password') {
                cloneNode.setAttribute('type', 'text')
            }
            cloneNode.setAttribute('value', placeholder||cloneNode.getAttribute('placeholder'));
        }
        //默认隐藏
        cloneNode.className =  cloneNode.className +' ie-placeholder'; //必须有空格 全局增加ie-placeholder样式
        cloneNode.style.display = 'none';
        cloneNode.style.color= '#C6CDD7'; //input颜色

        // 3.插入副本
        element.insertAdjacentHTML('afterend', cloneNode.outerHTML)
        element.nextSibling.addEventListener('focus', function () {
            this.style.display = 'none'
            this.previousSibling.style.display = 'inline-block'
            this.previousSibling.focus()
        })
        if (!element.value) {
            element.style.display = 'none'
            element.nextSibling.style.display = 'inline-block'
        }
        let _this = element;
        element.attachEvent('onpropertychange', (o)=>{
            if(o.propertyName === 'value'){
                if(_this.value) {
                    _this.style.display = 'inline-block';
                    _this.nextSibling.style.display = 'none';
                }else if(_this.value===''){
                    _this.style.display = 'none';
                    _this.nextSibling.style.display = 'inline-block';
                    _this.blur();
                }
            }
            return;
        });
    }
}

function getField(data, fields, realV) {
	let arr = fields.split('.');
	let key = arr.shift();
	let value = data[key];

	if (value === null || arr.length === 0) {
        data[key] = realV;
		return;
    }
    getField(value, arr.join('.'), realV);
}



// WEBPACK FOOTER //
// ./static/js/lib/ie9placeholder.js